import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SelectItem } from 'primeng';
import { EventService, JobsService, TaskService } from '../../../../services';
import {
  SupplierJobScreenTaskDetail,
  SupplierJobScreenTaskDetailTask,
} from '../../../../interfaces/screen-specific/job-screen/supplier/supplier-job-screen-task-detail';
import { OrganisationTypeEnum } from '../../../../enums/organisation-types';
import { IPricePremium } from '../../../../interfaces/price-premium';
import { JobScreenTaskDetails } from '../../../../interfaces/screen-specific/job-screen';

@Component({
  selector: 'supplier-job-screen-tasks',
  templateUrl: './supplier-job-screen-tasks.component.html',
  styleUrls: ['./supplier-job-screen-tasks.component.scss', '../../common/job-screen-common.scss'],
})
export class SupplierJobScreenTasksComponent implements OnInit, OnDestroy, OnChanges {
  @Input('jobId') jobId!: number;
  @Input('organisationId') organisationId!: number;
  @Input() supplierPremiums: IPricePremium[] = [];

  organisationTypeId: number = OrganisationTypeEnum.Supplier;

  tasks: SupplierJobScreenTaskDetailTask[] = [];
  job: SupplierJobScreenTaskDetail;
  actualTaskTypeId: number;
  taskTypeId: number;

  get supplierPremiumTotal(): number {
    return (this.supplierPremiums ?? []).reduce(
      (acc, p) => acc + Math.round(p.premium * 100) / 100,
      0,
    );
  }

  taskDetails: JobScreenTaskDetails[];
  selectedTask: JobScreenTaskDetails;

  subscriptions: Subscription[] = [];

  public taskTypes: SelectItem[] = [];
  activeIndex: number = 0;
  selectedTaskId: number;

  constructor(
    private jobService: JobsService,
    private eventService: EventService,
    private taskService: TaskService,
  ) {}

  async ngOnInit() {
    void this.loadJob();

    this.subscriptions.push(
      this.eventService.JobScreenEvent.subscribe((event: any) => {
        this.processEvents(event);
      }),
    );
  }

  private processEvents(event: any) {
    if (event.event == 'task-changed') {
      this.clickedTask(event.data.taskId, false);
    }
    if (event.event == 'refresh-supplier') {
      void this.loadJob();
    }
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.jobId.currentValue) {
      void this.loadJob();
    }
  }

  async loadJob() {
    // Load job
    const jobDetails: SupplierJobScreenTaskDetail = await this.jobService.getForComponent(
      this.jobId,
      'supplier-job-screen-tasks-detail',
    );

    this.job = jobDetails;
    this.tasks = jobDetails?.tasks || [];
    this.selectedTaskId = this.tasks[0]?.id;

    const taskDetails = await this.taskService.getJobScreenTaskDetails(
      this.tasks.map((task) => task.id),
    );

    this.taskDetails = taskDetails;
    this.selectedTask = taskDetails.find((taskDetails) => taskDetails.id == this.selectedTaskId);
  }

  clickedTask(taskId: any, sendEvent: boolean = true) {
    this.selectedTaskId = taskId;
    this.selectedTask = this.taskDetails?.find((taskDetails) => taskDetails.id == taskId);

    if (sendEvent) {
      this.eventService.JobScreenEvent.emit({
        event: 'task-changed',
        data: { taskId: taskId, jobId: this.jobId },
        sender: 'clickedTask',
      });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => x?.unsubscribe());
  }
}
